import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dns-manager',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DNSManagerController::index
* @see app/Http/Controllers/DNSManagerController.php:23
* @route '/dns-manager'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\DNSManagerController::storeRecord
* @see app/Http/Controllers/DNSManagerController.php:53
* @route '/dns-manager/{domain}/store-record'
*/
export const storeRecord = (args: { domain: number | { id: number } } | [domain: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeRecord.url(args, options),
    method: 'post',
})

storeRecord.definition = {
    methods: ["post"],
    url: '/dns-manager/{domain}/store-record',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\DNSManagerController::storeRecord
* @see app/Http/Controllers/DNSManagerController.php:53
* @route '/dns-manager/{domain}/store-record'
*/
storeRecord.url = (args: { domain: number | { id: number } } | [domain: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { domain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { domain: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            domain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        domain: typeof args.domain === 'object'
        ? args.domain.id
        : args.domain,
    }

    return storeRecord.definition.url
            .replace('{domain}', parsedArgs.domain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DNSManagerController::storeRecord
* @see app/Http/Controllers/DNSManagerController.php:53
* @route '/dns-manager/{domain}/store-record'
*/
storeRecord.post = (args: { domain: number | { id: number } } | [domain: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeRecord.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DNSManagerController::storeRecord
* @see app/Http/Controllers/DNSManagerController.php:53
* @route '/dns-manager/{domain}/store-record'
*/
const storeRecordForm = (args: { domain: number | { id: number } } | [domain: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeRecord.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DNSManagerController::storeRecord
* @see app/Http/Controllers/DNSManagerController.php:53
* @route '/dns-manager/{domain}/store-record'
*/
storeRecordForm.post = (args: { domain: number | { id: number } } | [domain: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeRecord.url(args, options),
    method: 'post',
})

storeRecord.form = storeRecordForm

/**
* @see \App\Http\Controllers\DNSManagerController::updateRecord
* @see app/Http/Controllers/DNSManagerController.php:41
* @route '/dns-manager/{record}/update-record'
*/
export const updateRecord = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateRecord.url(args, options),
    method: 'patch',
})

updateRecord.definition = {
    methods: ["patch"],
    url: '/dns-manager/{record}/update-record',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\DNSManagerController::updateRecord
* @see app/Http/Controllers/DNSManagerController.php:41
* @route '/dns-manager/{record}/update-record'
*/
updateRecord.url = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { record: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { record: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            record: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        record: typeof args.record === 'object'
        ? args.record.id
        : args.record,
    }

    return updateRecord.definition.url
            .replace('{record}', parsedArgs.record.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DNSManagerController::updateRecord
* @see app/Http/Controllers/DNSManagerController.php:41
* @route '/dns-manager/{record}/update-record'
*/
updateRecord.patch = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateRecord.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\DNSManagerController::updateRecord
* @see app/Http/Controllers/DNSManagerController.php:41
* @route '/dns-manager/{record}/update-record'
*/
const updateRecordForm = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateRecord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DNSManagerController::updateRecord
* @see app/Http/Controllers/DNSManagerController.php:41
* @route '/dns-manager/{record}/update-record'
*/
updateRecordForm.patch = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateRecord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateRecord.form = updateRecordForm

/**
* @see \App\Http\Controllers\DNSManagerController::deleteRecord
* @see app/Http/Controllers/DNSManagerController.php:65
* @route '/dns-manager/{record}/delete-record'
*/
export const deleteRecord = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteRecord.url(args, options),
    method: 'delete',
})

deleteRecord.definition = {
    methods: ["delete"],
    url: '/dns-manager/{record}/delete-record',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\DNSManagerController::deleteRecord
* @see app/Http/Controllers/DNSManagerController.php:65
* @route '/dns-manager/{record}/delete-record'
*/
deleteRecord.url = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { record: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { record: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            record: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        record: typeof args.record === 'object'
        ? args.record.id
        : args.record,
    }

    return deleteRecord.definition.url
            .replace('{record}', parsedArgs.record.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DNSManagerController::deleteRecord
* @see app/Http/Controllers/DNSManagerController.php:65
* @route '/dns-manager/{record}/delete-record'
*/
deleteRecord.delete = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteRecord.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\DNSManagerController::deleteRecord
* @see app/Http/Controllers/DNSManagerController.php:65
* @route '/dns-manager/{record}/delete-record'
*/
const deleteRecordForm = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteRecord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DNSManagerController::deleteRecord
* @see app/Http/Controllers/DNSManagerController.php:65
* @route '/dns-manager/{record}/delete-record'
*/
deleteRecordForm.delete = (args: { record: number | { id: number } } | [record: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteRecord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteRecord.form = deleteRecordForm

const dnsManager = {
    index: Object.assign(index, index),
    storeRecord: Object.assign(storeRecord, storeRecord),
    updateRecord: Object.assign(updateRecord, updateRecord),
    deleteRecord: Object.assign(deleteRecord, deleteRecord),
}

export default dnsManager